export default {
  titles: {
    delivery_address: 'Lieferadresse',
    location: 'Standort',
    date_time: 'Datum & Uhrzeit',
  },
  subtitles: {
    delivery_address: 'Geben Sie die Adresse ein, um die Lieferverfügbarkeit zu bestätigen',
  },
};
